/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import OrderOrderItemQueryResult from './OrderOrderItemQueryResult';
import OrderQueryResultTx from './OrderQueryResultTx';
import OrderQueryResultUser from './OrderQueryResultUser';

/**
 * The OrderQueryResult model module.
 * @module model/OrderQueryResult
 * @version 1.0
 */
class OrderQueryResult {
    /**
     * Constructs a new <code>OrderQueryResult</code>.
     * @alias module:model/OrderQueryResult
     */
    constructor() { 
        
        OrderQueryResult.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>OrderQueryResult</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/OrderQueryResult} obj Optional instance to populate.
     * @return {module:model/OrderQueryResult} The populated <code>OrderQueryResult</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OrderQueryResult();

            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'String');
            }
            if (data.hasOwnProperty('date')) {
                obj['date'] = ApiClient.convertToType(data['date'], 'String');
            }
            if (data.hasOwnProperty('deletedAt')) {
                obj['deletedAt'] = ApiClient.convertToType(data['deletedAt'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('items')) {
                obj['items'] = ApiClient.convertToType(data['items'], [OrderOrderItemQueryResult]);
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
            if (data.hasOwnProperty('tx')) {
                obj['tx'] = OrderQueryResultTx.constructFromObject(data['tx']);
            }
            if (data.hasOwnProperty('txId')) {
                obj['txId'] = ApiClient.convertToType(data['txId'], 'Number');
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'String');
            }
            if (data.hasOwnProperty('user')) {
                obj['user'] = OrderQueryResultUser.constructFromObject(data['user']);
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {String} createdAt
 */
OrderQueryResult.prototype['createdAt'] = undefined;

/**
 * @member {String} date
 */
OrderQueryResult.prototype['date'] = undefined;

/**
 * @member {String} deletedAt
 */
OrderQueryResult.prototype['deletedAt'] = undefined;

/**
 * @member {Number} id
 */
OrderQueryResult.prototype['id'] = undefined;

/**
 * @member {Array.<module:model/OrderOrderItemQueryResult>} items
 */
OrderQueryResult.prototype['items'] = undefined;

/**
 * @member {String} status
 */
OrderQueryResult.prototype['status'] = undefined;

/**
 * @member {module:model/OrderQueryResultTx} tx
 */
OrderQueryResult.prototype['tx'] = undefined;

/**
 * @member {Number} txId
 */
OrderQueryResult.prototype['txId'] = undefined;

/**
 * @member {String} updatedAt
 */
OrderQueryResult.prototype['updatedAt'] = undefined;

/**
 * @member {module:model/OrderQueryResultUser} user
 */
OrderQueryResult.prototype['user'] = undefined;

/**
 * @member {Number} userId
 */
OrderQueryResult.prototype['userId'] = undefined;






export default OrderQueryResult;

